import { useTranslation } from 'react-i18next'

import { BirdviewRowRelativeTime } from '../BirdviewRowRelativeTime'
import { DashboardListRow } from '../DashboardListRow'

import ChatIcon from '../../../icons/chats.svg'

function BirdviewMessageRow({ item, onOpen }) {
  const { t } = useTranslation()

  function handleOpen() {
    onOpen(item)
  }

  return (
    <DashboardListRow
      Icon={ChatIcon}
      Meta={BirdviewRowRelativeTime}
      isUnread={item.unread}
      metaProps={{ date: item.updated }}
      subtitle={item.subtitle}
      title={item.title || t('DashboardBirdview.NoChatTitleKey')}
      onAction={handleOpen}
      onOpen={handleOpen}
    />
  )
}

export default BirdviewMessageRow
